import { Component } from 'react';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import { Dispatch } from 'redux';
import { OpenModal, PortType, RootState, ToolTipType } from 'types';
import { MapControlsInterface } from 'types/functions';
import { checkDifferent, clone } from 'utils/formHandlers';
import {
    formatNumberWithCommas,
    metersToKilometers,
    metersToNauticalMiles,
    squareMetersToKilometers,
} from 'utils/unit';

interface MeasureToolTipProps {
    toolTip: ToolTipType;
    //unused props
    port: PortType;
    dragging: string | null;
    mode: string;
    mapControls: MapControlsInterface;
    updateDrawinglabel?: (id: string, name: string) => void;
    openModelFunction: OpenModal;
}

interface MeasureToolTipState {
    toolTip: ToolTipType | null;

    //unsed state and used in getDerivedStateFromProps
    loading: boolean;
    dragging: string | null;
}

class MeasureToolTip extends Component<MeasureToolTipProps, MeasureToolTipState> {
    constructor(props: MeasureToolTipProps) {
        super(props);
        this.state = {
            toolTip: clone(props.toolTip),
            loading: true,
            dragging: null,
        };
    }

    static getDerivedStateFromProps(props: MeasureToolTipProps, state: MeasureToolTipState) {
        if (checkDifferent(props.toolTip, state.toolTip) || checkDifferent(props.dragging, state.dragging)) {
            return {
                toolTip: clone(props.toolTip),
                loading: true,
            };
        }
        return null;
    }

    closeTooltip = async () => {
        switch (this.props.mode) {
            case 'search':
                await this.props.mapControls.chart?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.chart?.hideTooltipById(this.props.toolTip.uuid);
                break;
            case 'live':
            case 'time':
                await this.props.mapControls.time?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.time?.hideTooltipById(this.props.toolTip.uuid);
                break;
            case 'playback':
                await this.props.mapControls.playback?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.playback?.hideTooltipById(this.props.toolTip.uuid);
                break;

            default:
                break;
        }
    };

    updateLabelModel = () => {
        if (this.state.dragging !== null) {
            return;
        }
        this.props.openModelFunction(
            'labelDrawingModel',
            0,
            'medium',
            {
                id: this.state?.toolTip?.uuid,
                name: this.state?.toolTip?.data.name,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('labelDrawingModel');
                },
                onConfirm: (data) => {
                    //@ts-ignore
                    this.props.updateDrawinglabel(data.id, data.name);
                },
            },
            true
        );
    };

    render() {
        return (
            <div className="flex flex-col  min-w-18 relative overflow-hidden rounded-md">
                <div
                    onDoubleClick={this.updateLabelModel}
                    className="w-tooltip h-full absolute z-10"
                    id={`Drag-${this.state?.toolTip?.uuid}`}
                ></div>
                <div className="w-full flex flex-col p-1">
                    <div className="flex justify-between gap-x-1 text-sm items-start">
                        <div>
                            {this.state?.toolTip?.data.name && (
                                <div className="capitalize ">{this.state?.toolTip?.data.name}</div>
                            )}
                            <div>
                                {this.state?.toolTip?.data.type === 'length' ? (
                                    <>
                                        {formatNumberWithCommas(
                                            metersToNauticalMiles(this.state?.toolTip?.data.results.length).toFixed(2)
                                        )}{' '}
                                        NM (
                                        {this.state?.toolTip?.data.results.length > 1000
                                            ? formatNumberWithCommas(
                                                  metersToKilometers(this.state?.toolTip?.data.results.length).toFixed(
                                                      1
                                                  )
                                              )
                                            : formatNumberWithCommas(
                                                  this.state?.toolTip?.data.results.length.toFixed(0)
                                              )}
                                        {this.state?.toolTip?.data.results.length > 1000 ? ' km' : ' m'}) @
                                        {parseFloat(this.state?.toolTip?.data.results.bearing.toFixed(1))}°
                                    </>
                                ) : (
                                    <>
                                        {this.state?.toolTip?.data.results?.area > 100000
                                            ? formatNumberWithCommas(
                                                  squareMetersToKilometers(
                                                      this.state?.toolTip?.data.results?.area
                                                  ).toFixed(2)
                                              )
                                            : formatNumberWithCommas(
                                                  this.state?.toolTip?.data.results?.area?.toFixed(0)
                                              )}
                                        {this.state?.toolTip?.data.results?.area > 100000 ? ' km' : ' m'}
                                        <sup>2</sup>
                                    </>
                                )}
                            </div>
                        </div>
                        <div
                            data-close="true"
                            onClick={this.closeTooltip}
                            className="flex justify-center items-end justify-items-end cursor-pointer"
                        >
                            <Icon className="w-4 h-4">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M18 6l-12 12"></path>
                                <path d="M6 6l12 12"></path>
                            </Icon>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const measureToolTipStateToProps = (state: RootState) => ({
    port: state.port.port,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
    openModelFunction: state.layout.openModelFunction,
});

const measureToolTipDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(measureToolTipStateToProps, measureToolTipDispatchToProps)(MeasureToolTip);
